export default [
  {
    path: "/medicament",
    name: "medicament",
    component: () => import("@/views/medicament/index"),
    meta: {
      title: "药剂管理",
      keepAlive: true,
    },
  },
  {
    path: "/config",
    name: "config",
    component: () => import("@/views/plantConfig/index"),
    meta: {
      title: "厂站配置",
      keepAlive: true,
    },
  },
  {
    path: "/effluentConfig",
    name: "effluentConfig",
    component: () => import("@/views/effluentStandardConfig/index"),
    meta: {
      title: "出水标准配置",
      keepAlive: true,
    },
  },
  {
    path: "/camera",
    name: "camera",
    component: () => import("@/views/cameraConfig/index"),
    meta: {
      title: "摄像头账号配置",
      keepAlive: true,
    },
  },
  {
    path: "/reflection",
    name: "reflection",
    component: () => import("@/views/orgNameReflection/index"),
    meta: {
      title: "账号名称映射配置",
      keepAlive: true,
    },
  },
  {
    path: "/internal",
    name: "internal",
    component: () => import("@/views/internalControlConfig/index"),
    meta: {
      title: "内控标准",
      keepAlive: true,
    },
  },
  {
    path: "/location",
    name: "location",
    component: () => import("@/views/location/index"),
    meta: {
      title: "所属位置",
      keepAlive: true,
    },
  },
  {
    path: "/knowledgeBase",
    name: "knowledgeBase",
    component: () => import("@/views/about.vue"),
    meta: {
      title: "知识库",
      keepAlive: true,
    },
    children: [
      {
        path: "articleMaintenance",
        name: "articleMaintenance",
        component: () => import("@/views/knowledgeBase/articleMaintenance/index"),
        meta: {
          title: "文章维护",
          keepAlive: true,
        },
      },
      {
        path: "directory",
        name: "directory",
        component: () => import("@/views/knowledgeBase/directory/index"),
        meta: {
          title: "目录维护",
          keepAlive: true,
        },
      },
      {
        path: "question",
        name: "question",
        component: () => import("@/views/knowledgeBase/question/index"),
        meta: {
          title: "问答管理",
          keepAlive: true,
        },
      },
    ],
  },
];
